import { useCallback, useState } from "react";

import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog/dialog";
import { Image } from "@/components/ui/image/image";

type Props = {
	imageSrc: string;
};

export const ImageAndDialog = ({ imageSrc }: Props) => {
	const [open, setOpen] = useState(false);
	const handleOpenChange = useCallback(() => {
		setOpen((prev) => !prev); //
	}, []);

	return (
		<Dialog open={open} onOpenChange={handleOpenChange}>
			<DialogTrigger asChild>
				<Image src={imageSrc} className="h-auto w-[600px] !p-0" />
			</DialogTrigger>

			<DialogContent className="max-w-[700px]">
				<div className="flex justify-center">
					<Image src={imageSrc} className="h-auto w-[600px]" />
				</div>
			</DialogContent>
		</Dialog>
	);
};

ImageAndDialog.displayName = "ImageAndDialog";
